import {
  object,
  array,
  string,
  func,
  bool,
  oneOfType,
  number,
} from 'prop-types'
import { kuiperClassNames } from '../../utils'
import Label from '../InputLabel'
import Select from '../Select'

const LabeledSelect = ({
  className,
  customFooter,
  disabled = false,
  labelText,
  noOptionsText,
  noOptionsElement,
  onSelect,
  options,
  placeholder,
  secondaryAction = false,
  shouldValidate = true,
  showDeselectIcon = false,
  theme = 'dark',
  truncateValueAt,
  valid = true,
  value,
}) => (
  <div className={kuiperClassNames('select-wrapper', className)}>
    <Label
      secondaryAction={secondaryAction}
      shouldValidate={shouldValidate}
      text={labelText}
      valid={valid}
    />
    <Select
      customFooter={customFooter}
      disabled={disabled}
      searchable={true}
      showDeselectIcon={showDeselectIcon}
      className={className}
      theme={theme}
      noOptionsText={noOptionsText}
      noOptionsElement={noOptionsElement}
      onSelect={onSelect}
      options={options}
      value={value}
      placeholder={placeholder}
      truncateValueAt={truncateValueAt}
    />
  </div>
)
LabeledSelect.displayName = 'Kuiper: LabeledSelect ← Inputs'

LabeledSelect.propTypes = {
  className: string,
  customFooter: object,
  disabled: bool,
  labelText: oneOfType([array, string, object]),
  noOptionsText: string,
  noOptionsElement: object,
  onSelect: func,
  options: array,
  placeholder: string,
  secondaryAction: bool,
  shouldValidate: bool,
  showDeselectIcon: bool,
  theme: string,
  truncateValueAt: number,
  valid: bool,
  value: object,
}

export default LabeledSelect
